module.exports = __webpack_public_path__ + "static/branded-bg-dark-4e4a9813a84a1a9fd07f120888cfbf75.jpg";